import React from 'react';

import {SvgIcon} from './SvgIcon';

export const HeartIconLabel: SvgIcon = ({
  width = 20,
  height = 18,
  fillColor = 'none',
  strokeColor = '#4B5563',
  classes = 'h-4 w-4 inline mr-3',
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    className={classes}
    viewBox="0 0 14 13"
  >
    <g>
      <path
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.9999 7.04795L6.99987 12L1.99988 7.04795C1.67008 6.72703 1.4103 6.3413 1.23691 5.91505C1.06351 5.48879 0.98025 5.03126 0.992367 4.57124C1.00448 4.11123 1.11172 3.65871 1.30731 3.24218C1.50291 2.82565 1.78263 2.45412 2.12887 2.15101C2.4751 1.84789 2.88035 1.61975 3.31908 1.48094C3.75782 1.34214 4.22055 1.29568 4.67812 1.34449C5.1357 1.3933 5.57821 1.53633 5.97779 1.76456C6.37738 1.99279 6.72537 2.30129 6.99987 2.67062C7.27556 2.30397 7.62397 1.99817 8.02328 1.77236C8.42258 1.54655 8.8642 1.40559 9.3205 1.3583C9.77679 1.31102 10.2379 1.35842 10.6751 1.49755C11.1122 1.63668 11.5159 1.86454 11.8609 2.16686C12.2059 2.46919 12.4848 2.83948 12.6802 3.25455C12.8755 3.66962 12.983 4.12054 12.9961 4.57909C13.0091 5.03764 12.9274 5.49395 12.756 5.91946C12.5845 6.34496 12.3271 6.7305 11.9999 7.05196"
      />
    </g>
  </svg>
);

export const MedicineIconLabel: SvgIcon = ({
  width = 8,
  height = 14,
  fillColor = 'none',
  strokeColor = '#4B5563',
  classes = 'h-4 w-4 inline mr-3',
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    className={classes}
    viewBox="0 0 8 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.33366 3.66667C5.86409 3.66667 6.3728 3.87738 6.74787 4.25245C7.12295 4.62753 7.33366 5.13623 7.33366 5.66667V12.3333C7.33366 12.5101 7.26342 12.6797 7.1384 12.8047C7.01337 12.9298 6.8438 13 6.66699 13H1.33366C1.15685 13 0.987279 12.9298 0.862254 12.8047C0.73723 12.6797 0.666992 12.5101 0.666992 12.3333V5.66667C0.666992 5.13623 0.877706 4.62753 1.25278 4.25245C1.62785 3.87738 2.13656 3.66667 2.66699 3.66667M5.33366 3.66667H2.66699M5.33366 3.66667V1.66667C5.33366 1.48986 5.26342 1.32029 5.1384 1.19526C5.01337 1.07024 4.8438 1 4.66699 1H3.33366C3.15685 1 2.98728 1.07024 2.86225 1.19526C2.73723 1.32029 2.66699 1.48986 2.66699 1.66667V3.66667M2.66699 8.33333H5.33366M4.00033 7V9.66667"
      />
    </g>
  </svg>
);

export const EditPencilLabel: SvgIcon = ({
  width = 18,
  height = 18,
  fillColor = '#315EFF',
  strokeColor = '#FFFFFF',
  strokeWidth = 0.6,
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    viewBox="0 0 8 8"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <g>
      <path
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M4.9231 1.75506L6.57494 3.4069M1 7.33H2.65183L6.98789 2.99394C7.20694 2.77489 7.33 2.4778 7.33 2.16802C7.33 1.85824 7.20694 1.56115 6.98789 1.34211C6.76885 1.12306 6.47176 1 6.16198 1C5.8522 1 5.55511 1.12306 5.33606 1.34211L1 5.67817V7.33Z"
      />
    </g>
  </svg>
);

export const ShareLinkIcon: SvgIcon = ({
  width = 20,
  height = 20,
  fillColor = '#FFFFFF',
  strokeColor = 'text-[#6B7280]',
  strokeWidth = 1.5,
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    className={`stroke-current share-link-icon ${strokeColor}`}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M6.7 8.7L13.3 5.3M6.7 11.3L13.3 14.7M7 10C7 11.6569 5.65685 13 4 13C2.34315 13 1 11.6569 1 10C1 8.34315 2.34315 7 4 7C5.65685 7 7 8.34315 7 10ZM19 4C19 5.65685 17.6569 7 16 7C14.3431 7 13 5.65685 13 4C13 2.34315 14.3431 1 16 1C17.6569 1 19 2.34315 19 4ZM19 16C19 17.6569 17.6569 19 16 19C14.3431 19 13 17.6569 13 16C13 14.3431 14.3431 13 16 13C17.6569 13 19 14.3431 19 16Z"
      />
    </g>
  </svg>
);

export const SettingsIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = 'text-[#747474]',
  strokeWidth = 1.5,
  fillColor = 'none',
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 22 22"
    className={`stroke-current ${strokeColor}`}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.1709 14.2C12.8277 14.2 14.1709 12.8568 14.1709 11.2C14.1709 9.5431 12.8277 8.19995 11.1709 8.19995C9.51401 8.19995 8.17087 9.5431 8.17087 11.2C8.17087 12.8568 9.51401 14.2 11.1709 14.2Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12.7654 1.15224C12.3978 1 11.9319 1 11 1C10.0681 1 9.60221 1 9.23461 1.15224C8.74458 1.35523 8.35523 1.74458 8.15224 2.23463C8.05958 2.45834 8.02331 2.7185 8.00912 3.09799C7.98827 3.65568 7.70227 4.17189 7.21895 4.45093C6.73565 4.72996 6.1456 4.71954 5.6522 4.45876C5.31646 4.2813 5.07302 4.18262 4.83295 4.15102C4.30705 4.08178 3.77519 4.22429 3.35437 4.5472C3.03875 4.78938 2.80578 5.1929 2.33984 5.99993C1.8739 6.80697 1.64093 7.21048 1.589 7.60491C1.51977 8.1308 1.66228 8.66266 1.98519 9.0835C2.13257 9.2756 2.33971 9.437 2.6612 9.639C3.13381 9.936 3.4379 10.4419 3.43787 11C3.43784 11.5581 3.13376 12.0639 2.66119 12.3608C2.33966 12.5629 2.13249 12.7244 1.98509 12.9165C1.66218 13.3373 1.51967 13.8691 1.58891 14.395C1.64083 14.7894 1.8738 15.193 2.33974 16C2.80569 16.807 3.03866 17.2106 3.35427 17.4527C3.77509 17.7756 4.30695 17.9181 4.83285 17.8489C5.0729 17.8173 5.31633 17.7186 5.65205 17.5412C6.14548 17.2804 6.73557 17.27 7.21891 17.549C7.70225 17.8281 7.98827 18.3443 8.00912 18.9021C8.02332 19.2815 8.05958 19.5417 8.15224 19.7654C8.35523 20.2554 8.74458 20.6448 9.23461 20.8478C9.60221 21 10.0681 21 11 21C11.9319 21 12.3978 21 12.7654 20.8478C13.2554 20.6448 13.6448 20.2554 13.8477 19.7654C13.9404 19.5417 13.9767 19.2815 13.9909 18.902C14.0117 18.3443 14.2977 17.8281 14.781 17.549C15.2643 17.2699 15.8544 17.2804 16.3479 17.5412C16.6836 17.7186 16.927 17.8172 17.167 17.8488C17.6929 17.9181 18.2248 17.7756 18.6456 17.4527C18.9612 17.2105 19.1942 16.807 19.6601 15.9999C20.1261 15.1929 20.3591 14.7894 20.411 14.395C20.4802 13.8691 20.3377 13.3372 20.0148 12.9164C19.8674 12.7243 19.6602 12.5628 19.3387 12.3608C18.8662 12.0639 18.5621 11.558 18.5621 10.9999C18.5621 10.4418 18.8662 9.9361 19.3387 9.6392C19.6603 9.4371 19.8675 9.2757 20.0149 9.0835C20.3378 8.66273 20.4803 8.13087 20.4111 7.60497C20.3592 7.21055 20.1262 6.80703 19.6602 6C19.1943 5.19297 18.9613 4.78945 18.6457 4.54727C18.2249 4.22436 17.693 4.08185 17.1671 4.15109C16.9271 4.18269 16.6837 4.28136 16.3479 4.4588C15.8545 4.71959 15.2644 4.73002 14.7811 4.45096C14.2977 4.17191 14.0117 3.65566 13.9909 3.09794C13.9767 2.71848 13.9404 2.45833 13.8477 2.23463C13.6448 1.74458 13.2554 1.35523 12.7654 1.15224Z"
    />
  </svg>
);

export const TherapistIcon: SvgIcon = ({strokeColor = '#2E62EC'}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="66"
      height="74"
      viewBox="0 0 66 74"
      fill="none"
    >
      <path
        d="M27 29H39V40.9289C39 42.255 39.5268 43.5268 40.4645 44.4645L42 46L36 60H30L24 46L25.5355 44.4645C26.4732 43.5268 27 42.255 27 40.9289V29Z"
        fill="white"
        stroke={strokeColor}
        strokeWidth="2"
      />
      <path
        d="M4.76107 53.9557C5.51658 50.9336 7.95759 48.625 11.017 48.0389L24 45.5517L31.3379 56.5163C32.1299 57.6999 33.8701 57.6999 34.6621 56.5163L42 45.5517L54.983 48.0389C58.0424 48.625 60.4834 50.9336 61.2389 53.9557L64.7575 68.0298C65.3886 70.5544 63.4792 73 60.8769 73H5.1231C2.52082 73 0.611389 70.5544 1.24254 68.0298L4.76107 53.9557Z"
        fill="white"
        stroke={strokeColor}
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.8885 8C9.77877 8.38817 9.68944 8.78574 9.62179 9.19161L6.95512 25.1916C5.83765 31.8965 11.0081 38 17.8055 38H48.1962C54.9936 38 60.1641 31.8965 59.0466 25.1916L56.3799 9.19161C56.3123 8.78574 56.2229 8.38817 56.1132 8H54.0158C54.1878 8.48746 54.3196 8.99545 54.4071 9.52041L57.0738 25.5204C57.9881 31.0062 53.7577 36 48.1962 36H17.8055C12.244 36 8.01361 31.0062 8.92791 25.5204L11.5946 9.52041C11.6821 8.99545 11.8139 8.48746 11.9859 8H9.8885Z"
        fill={strokeColor}
      />
      <path
        d="M17 6H49V25C49 33.8366 41.8366 41 33 41C24.1634 41 17 33.8366 17 25V6Z"
        fill="white"
        stroke={strokeColor}
        strokeWidth="2"
      />
      <path
        d="M33 4C33 2.34315 31.6569 1 30 1H20.4713C15.5829 1 11.411 4.53413 10.6073 9.35601L9.5 16H22C28.0751 16 33 11.0751 33 5V4Z"
        fill="white"
        stroke={strokeColor}
        strokeWidth="2"
      />
      <path
        d="M33 4C33 2.34315 34.3431 1 36 1H45.5287C50.4171 1 54.589 4.53413 55.3927 9.35601L56.5 16H44C37.9249 16 33 11.0751 33 5V4Z"
        fill="white"
        stroke="#2E62EC"
        strokeWidth="2"
      />
      <path
        d="M33 24L35.6382 29.2764C35.8044 29.6088 35.5627 30 35.191 30H32"
        stroke="#2E62EC"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12.5 73V61.5"
        stroke="#2E62EC"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M38 63C38 61.8954 38.8954 61 40 61H47C48.1046 61 49 61.8954 49 63V67C49 68.1046 48.1046 69 47 69H40C38.8954 69 38 68.1046 38 67V63Z"
        stroke="#2E62EC"
        strokeWidth="2"
      />
      <path
        d="M53.5 73V61.5"
        stroke="#2E62EC"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const PrescriberIcon: SvgIcon = ({
  width = 66,
  height = 71,
  fillColor = 'none',
  strokeColor = '#2E62EC',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 66 71"
    fill={fillColor}
  >
    <path
      fill={strokeColor}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42 4H10C5.58172 4 2 7.58172 2 12V60C2 64.4183 5.58172 68 10 68H42C46.4183 68 50 64.4183 50 60V35.9286L52 30.4429V60C52 65.5228 47.5228 70 42 70H10C4.47715 70 0 65.5228 0 60V12C0 6.47715 4.47715 2 10 2H42C44.0393 2 45.936 2.61042 47.5174 3.65852C47.5149 3.66433 47.5124 3.67016 47.51 3.676L46.7302 5.54756C45.4053 4.57466 43.7698 4 42 4ZM29.8367 57.1835L28.852 57.8055C27.8734 58.4235 26.6266 58.4235 25.648 57.8055L25.17 57.5035C23.539 56.4735 21.461 56.4735 19.83 57.5035L19.352 57.8055C18.3734 58.4235 17.1266 58.4235 16.148 57.8055L15.67 57.5035C14.039 56.4735 11.961 56.4735 10.33 57.5035L7.71601 59.1545C7.24906 59.4494 7.10959 60.067 7.40451 60.534C7.69943 61.0009 8.31704 61.1404 8.78399 60.8455L11.398 59.1945C12.3766 58.5765 13.6234 58.5765 14.602 59.1945L15.08 59.4965C16.711 60.5265 18.789 60.5265 20.42 59.4965L20.898 59.1945C21.8766 58.5765 23.1234 58.5765 24.102 59.1945L24.58 59.4965C26.211 60.5265 28.289 60.5265 29.92 59.4965L30.2568 59.2837L29.8367 57.1835ZM6 14C6 12.3431 7.34315 11 9 11H26C27.6569 11 29 12.3431 29 14V18C29 19.6569 27.6569 21 26 21H9C7.34315 21 6 19.6569 6 18V14ZM9 13C8.44772 13 8 13.4477 8 14V18C8 18.5523 8.44772 19 9 19H26C26.5523 19 27 18.5523 27 18V14C27 13.4477 26.5523 13 26 13H9ZM6 27C6 26.4477 6.44772 26 7 26H31C31.5523 26 32 26.4477 32 27C32 27.5523 31.5523 28 31 28H7C6.44772 28 6 27.5523 6 27ZM7 33C6.44772 33 6 33.4477 6 34C6 34.5523 6.44772 35 7 35H25C25.5523 35 26 34.5523 26 34C26 33.4477 25.5523 33 25 33H7ZM6 41C6 40.4477 6.44772 40 7 40H25C25.5523 40 26 40.4477 26 41C26 41.5523 25.5523 42 25 42H7C6.44772 42 6 41.5523 6 41Z"
    />
    <path
      fill={strokeColor}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M50.5205 2.24003C48.4446 1.48446 46.1492 2.55481 45.3936 4.63072L43.6835 9.32918L28.4651 51.1415C28.4285 51.242 28.3974 51.3442 28.3719 51.4475C28.3409 51.4999 28.3142 51.556 28.2926 51.6153C28.2112 51.839 28.2146 52.0728 28.2863 52.2817C28.2904 52.3882 28.3001 52.4947 28.3156 52.6007L30.1063 64.8742C30.3362 66.4503 32.2265 67.1383 33.4158 66.0788L42.6768 57.8277C42.7568 57.7565 42.8327 57.6811 42.9042 57.6021C43.0934 57.4883 43.2463 57.3113 43.3277 57.0877C43.3493 57.0283 43.3649 56.9683 43.3749 56.9081C43.4217 56.8126 43.4636 56.7144 43.5002 56.6138L58.7186 14.8015L59.0606 13.8618L60.0003 14.2038C60.5193 14.3927 60.7869 14.9666 60.598 15.4855L52.9026 36.6286C52.7137 37.1476 52.9812 37.7214 53.5002 37.9103C54.0192 38.0992 54.593 37.8316 54.7819 37.3127L62.4774 16.1696C63.0441 14.6127 62.2413 12.8911 60.6844 12.3244L59.7447 11.9824L60.4287 10.103C61.1843 8.02713 60.1139 5.73176 58.038 4.97619L50.5205 2.24003ZM57.5233 12.2381L58.5493 9.419C58.9271 8.38104 58.3919 7.23336 57.354 6.85557L49.8364 4.11941C48.7985 3.74163 47.6508 4.2768 47.273 5.31476L45.9049 9.07353L57.1813 13.1778L57.5233 12.2381ZM32.0853 64.5855L30.4636 53.4697L40.4728 57.1127L32.0853 64.5855ZM30.514 51.3597L41.7903 55.4639L56.4972 15.0572L45.2209 10.9529L30.514 51.3597Z"
    />
  </svg>
);

export const GreenCheckMarkIcon: SvgIcon = ({strokeColor = 'white'}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="72"
    height="54"
    viewBox="0 0 72 54"
    fill="none"
  >
    <path
      d="M5 27L25 47L67 5"
      stroke={strokeColor}
      strokeWidth="9"
      strokeLinecap="round"
    />
  </svg>
);

export const UnionIcon: SvgIcon = ({strokeColor}) => (
  <svg
    width="26"
    height="37"
    viewBox="0 0 26 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      stroke={strokeColor}
      d="M13 23.75C18.8853 23.75 23.6562 18.979 23.6562 13.0938C23.6562 7.20847 18.8853 2.4375 13 2.4375C7.11472 2.4375 2.34375 7.20847 2.34375 13.0938C2.34375 18.979 7.11472 23.75 13 23.75ZM13 25.75C15.8401 25.75 18.4617 24.8145 20.5735 23.2348V33.1973C20.5735 33.9323 19.8072 34.4162 19.1436 34.1002L14.2897 31.7888C13.4738 31.4003 12.5261 31.4003 11.7101 31.7888L6.85627 34.1002C6.19267 34.4162 5.42634 33.9323 5.42634 33.1973V23.2347C7.53815 24.8145 10.1598 25.75 13 25.75ZM25.6562 13.0938C25.6562 16.4013 24.3875 19.4126 22.31 21.6673H22.5735V33.1973C22.5735 35.4023 20.2745 36.8539 18.2837 35.9059L13.4299 33.5946C13.1579 33.465 12.842 33.465 12.57 33.5946L7.71614 35.9059C5.72532 36.8539 3.42634 35.4023 3.42634 33.1973V21.6673H3.68998C1.61255 19.4126 0.34375 16.4013 0.34375 13.0938C0.34375 6.1039 6.01015 0.4375 13 0.4375C19.9899 0.4375 25.6562 6.1039 25.6562 13.0938ZM19.4229 11.3513C19.8134 10.9608 19.8134 10.3276 19.4229 9.93707C19.0323 9.54655 18.3992 9.54655 18.0087 9.93707L11.367 16.5788L8.39968 13.6115C8.00916 13.2209 7.37599 13.2209 6.98547 13.6115C6.59494 14.002 6.59494 14.6352 6.98547 15.0257L9.95275 17.993C10.7338 18.774 12.0001 18.774 12.7812 17.993L19.4229 11.3513Z"
      fill="white"
    />
  </svg>
);

export const HourGlassIcon: SvgIcon = ({strokeColor}) => (
  <svg
    width="24"
    height="34"
    viewBox="0 0 24 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      stroke={strokeColor}
      clipRule="evenodd"
      d="M1.0625 0.00012207C0.510215 0.00012207 0.0625 0.447837 0.0625 1.00012C0.0625 1.55241 0.510215 2.00012 1.0625 2.00012H1.81242V7.56262C1.81242 11.6104 4.1731 15.1068 7.59281 16.7501C4.1731 18.3935 1.81242 21.8899 1.81242 25.9377V31.5002H1.0625C0.510215 31.5002 0.0625 31.9479 0.0625 32.5002C0.0625 33.0524 0.510215 33.5002 1.0625 33.5002H3.56242H20.4374H21.1731C21.182 33.5003 21.191 33.5003 21.1999 33.5002H22.9375C23.4898 33.5002 23.9375 33.0524 23.9375 32.5002C23.9375 31.9479 23.4898 31.5002 22.9375 31.5002H22.1874V25.9377C22.1874 21.8899 19.8267 18.3935 16.407 16.7501C18.1883 15.8941 19.6823 14.5353 20.7049 12.8577C21.0621 12.7052 21.3125 12.3507 21.3125 11.9377C21.3125 11.8707 21.3059 11.8053 21.2934 11.7421C21.8678 10.4668 22.1874 9.05204 22.1874 7.56262V2.00012H22.9375C23.4898 2.00012 23.9375 1.55241 23.9375 1.00012C23.9375 0.447837 23.4898 0.00012207 22.9375 0.00012207H20.4374H3.56242H1.0625ZM20.1874 30.6316V25.9377C20.1874 21.7544 17.0501 18.3038 12.9999 17.8106V26.0835C13.4054 26.1949 13.7969 26.3713 14.1586 26.6124L20.1874 30.6316ZM10.9999 26.0525V17.8106C6.94978 18.3038 3.81242 21.7543 3.81242 25.9377V30.2675L9.83442 26.5396C10.2009 26.3127 10.5946 26.1504 10.9999 26.0525ZM5.62091 31.5002H17.8847L13.0492 28.2765C12.3978 27.8422 11.5528 27.828 10.8871 28.2401L5.62091 31.5002ZM20.1874 2.00012H3.81242V7.56262C3.81242 8.76591 4.07199 9.90857 4.5382 10.9377H19.4616C19.9278 9.90857 20.1874 8.76591 20.1874 7.56262V2.00012ZM5.82367 12.9377C7.3231 14.6591 9.53046 15.7478 11.9921 15.7501L11.9999 15.7501L12.0077 15.7501C14.4694 15.7478 16.6767 14.6591 18.1762 12.9377H5.82367Z"
      fill="white"
    />
  </svg>
);

export const PersonIcon: SvgIcon = ({strokeColor}) => (
  <svg
    width="34"
    height="38"
    viewBox="0 0 34 38"
    fill="none"
    stroke={strokeColor}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0852 15.196H19.9147V19.9361C19.9147 21.2558 20.439 22.5214 21.3721 23.4546L18.4573 30.2557H15.5426L12.6278 23.4546C13.5609 22.5214 14.0852 21.2558 14.0852 19.9361V15.196Z"
      fill="#2E62EC"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M2.64459 29.8678C3.4001 26.8458 5.84111 24.5371 8.90053 23.951L12.6278 23.2369L15.3379 27.2864C16.1299 28.4699 17.8701 28.4699 18.6621 27.2864L21.3722 23.2369L25.0995 23.951C28.1589 24.5371 30.5999 26.8458 31.3554 29.8678L31.7887 31.601C32.4199 34.1256 30.5104 36.5712 27.9081 36.5712H6.09186C3.48957 36.5712 1.58014 34.1256 2.21129 31.601L2.64459 29.8678Z"
      fill="#2E62EC"
      stroke="white"
      strokeWidth="2"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.05642 4.99402C5.33189 6.09787 4.82303 7.36338 4.59426 8.73597C3.60435 14.6754 8.18459 20.0822 14.206 20.0822H19.7943C25.8157 20.0822 30.396 14.6754 29.406 8.73597C29.1773 7.36338 28.6684 6.09787 27.9439 4.99402H25.3996C26.4404 6.0849 27.1701 7.48567 27.4333 9.06477C28.22 13.7852 24.5798 18.0822 19.7943 18.0822H14.206C9.42047 18.0822 5.78031 13.7852 6.56705 9.06477C6.83023 7.48567 7.55987 6.0849 8.60067 4.99402H6.05642Z"
      fill="white"
    />
    <path
      d="M9.22724 4.02271H24.7727V13.2528C24.7727 17.5456 21.2927 21.0255 17 21.0255C12.7072 21.0255 9.22724 17.5456 9.22724 13.2528V4.02271Z"
      fill="#2E62EC"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M17 3.15524C17 2.29285 16.3009 1.59375 15.4385 1.59375H10.9136C8.53887 1.59375 6.51218 3.31061 6.12177 5.65306L5.58383 8.88068H11.2746C14.4367 8.88068 17 6.31731 17 3.15524Z"
      fill="#2E62EC"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M17 3.15524C17 2.29285 17.6991 1.59375 18.5615 1.59375H23.0864C25.4611 1.59375 27.4878 3.31061 27.8782 5.65306L28.4162 8.88068H22.7254C19.5633 8.88068 17 6.31731 17 3.15524Z"
      fill="#2E62EC"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M17.0001 12.767L18.0956 14.9581C18.2619 15.2906 18.0201 15.6817 17.6484 15.6817H16.5143"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7.04124 36.571V30.9844"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M19.4291 32.6848C19.4291 31.6116 20.2991 30.7416 21.3723 30.7416H22.8296C23.9028 30.7416 24.7728 31.6116 24.7728 32.6848V32.6848C24.7728 33.7579 23.9028 34.6279 22.8296 34.6279H21.3723C20.2991 34.6279 19.4291 33.7579 19.4291 32.6848V32.6848Z"
      stroke="white"
      strokeWidth="2"
    />
    <path
      d="M26.9588 36.571V30.9844"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export const HamburgerMenuIcon: SvgIcon = ({
  width = 32,
  height = 29,
  strokeColor = 'text-black',
  strokeWidth,
  fillColor = 'none',
  classes = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 29"
    stroke={strokeColor}
    strokeWidth={strokeWidth}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 10H22V11H10V10ZM10 14H22V15H10V14ZM22 18H10V19H22V18Z"
      fill="black"
    />
    <rect x="0.5" y="0.5" width="31" height="28" rx="8.5" stroke="black" />
  </svg>
);
